export interface FAQEntry {
    question: string;
    answer: string[];
}

export const FAQsData = [
    {
        question: 'What is my Online Order History?',
        answer: [
            'Your Online Order History keeps track of all your online earnings and online shopping activity through RaiseRight.',
            'Each time you click "Shop Now" on a brand detail page on RaiseRight, it\'s recorded in your Online Order History, even if you don\'t make a purchase.',
        ],
    },
    {
        question: 'What are online earnings?',
        answer: [
            'Online earnings are complementary to gift card earnings and are received by shopping online through RaiseRight. Click the “Shop Now” button on a brand detail page to shop directly on the brand’s website and complete a purchase to receive online earnings.',
        ],
    },
    {
        question: 'Do I need to claim my online earnings?',
        answer: [
            'No, if you complete a purchase on a brand\'s website after clicking through from RaiseRight, your earnings will display in your Online Order History once the "Earn by" date has passed.',
            'If your online earnings do not display, and the "Earn by" date has passed, then you can submit a claim by tapping the "Claim" button.',
        ],
    },
    {
        question: 'What is the ‘Earn by’ date?',
        answer: [
            'The "Earn by" date listed next to each shopping trip is when you need to complete a purchase on that brand\'s website in order to receive online earnings (typically within 24-48 hours). Once the retailer verifies your purchase, the "Earn by" date is replaced with your earnings amount for that shopping trip.',
            'If you completed an online purchase with a brand and online earnings do not display after the "Earn by" date, select the "Claim" button to submit a claim.',
        ],
    },
    {
        question: 'I’m missing online earnings—what can I do?',
        answer: [
            'If online earnings do not display after you complete an online purchase by the "Earn by" date, you can submit a claim by selecting the "Claim" button next to the shopping trip. Keep in mind that purchases made with rewards, loyalty points, or third-party coupons and promo codes may void eligibility for online earnings.',
            '(Please note: For categories like hotels, travel, car rentals, and ticket-related transactions, online earnings may be issued up to 2 weeks after the stay or event has been completed.)',
        ],
    },
    {
        question:
            'I returned an item that I already received online earnings for. What happens next?',
        answer: [
            "If you've returned an item that was purchased and has pending earnings, those earnings will be removed (either for the full purchase or the returned portion of your full purchase) before those earnings are transferred to your organization. Earnings are no longer considered pending 45 days after your transaction and can take up to 90 days to be deposited to your organization.  ",
        ],
    },
    {
        question: 'How long does it take for my online earnings to transfer to my organization?',
        answer: [
            "It typically takes 45-90 days for online earnings to transfer to your organization. This timeline accounts for each brand's return window and RaiseRight's monthly payout schedule.  ",
        ],
    },
    {
        question:
            'I see the term ‘cashback’ within my confirmation emails and order history. What is that?',
        answer: [
            '‘Cashback’ is another term sometimes used to reference your online earnings that go back to your organization when you shop online through RaiseRight.',
        ],
    },
];
